module.exports = __webpack_public_path__ + "img/Access-to-Safe-Drinking-Water-1110x450.7cf3a0f1.png";